import type { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { LogoutButton } from './LogoutButton';

interface NavItem {
  to: string;
  label: string;
}

const NAV_ITEMS: NavItem[] = [{ to: '/search', label: 'Vehicle search' }];

function navLinkClass({ isActive }: { isActive: boolean }): string {
  return isActive ? 'vap-sidebar__link vap-sidebar__link--active' : 'vap-sidebar__link';
}

export function Sidebar(): ReactElement {
  const { user, availableRoutes } = useAuth();
  const visibleItems = NAV_ITEMS.filter((item) => availableRoutes.includes(item.to));

  return (
    <aside className="vap-sidebar">
      <div className="vap-sidebar__brand">
        <span className="vap-sidebar__brand-title">Vehicle Advertising Portal</span>
      </div>

      <nav className="vap-sidebar__nav">
        {visibleItems.map((item) => (
          <NavLink key={item.to} to={item.to} className={navLinkClass}>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="vap-sidebar__account">
        <span className="vap-sidebar__account-email" title={user?.name ?? ''}>
          {user?.name}
        </span>
        <LogoutButton />
      </div>
    </aside>
  );
}
